import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  container: wb-dashboard/inline-size;
  min-width: 0;
  display: block;
  height: 100%;
  min-width: 0;
  color: #102739;
  background: var(--wb-page-canvas, #f5f9fd);
}

.dashboard-notebook-scale {
  width: 100%;
  min-width: 0;
}

.dashboard-header {
  border-bottom: 1px solid #dce5eb;
  background: #ffffff;
}

.dashboard-header-inner,
.dashboard-main {
  width: 100%;
  max-width: 106rem;
  margin: 0 auto;
}

.dashboard-header-inner {
  display: flex;
  min-height: 5.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.25rem 2rem;
}

.dashboard-brand {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 1rem;
}

.dashboard-brand h1 {
  flex: 0 0 auto;
  color: #0b2134;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.dashboard-brand-divider {
  width: 1px;
  height: 1.5rem;
  flex: 0 0 auto;
  background: #d8e1e7;
}

.dashboard-brand p {
  overflow: hidden;
  color: #607381;
  font-size: 0.8125rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dashboard-header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
}

.dashboard-header-actions time {
  margin-right: 0.5rem;
  color: #394e5e;
  font-size: 0.8125rem;
  font-weight: 500;
}

.dashboard-search {
  position: relative;
  display: flex;
  width: 15rem;
  height: 3rem;
  align-items: center;
}

.dashboard-search input {
  width: 100%;
  height: 100%;
  border: 1px solid #cad6df;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0 2.75rem 0 0.9rem;
  color: #183244;
  font-size: 0.8125rem;
}

.dashboard-search i {
  position: absolute;
  right: 0.95rem;
  color: #718493;
  pointer-events: none;
}

.dashboard-register {
  display: inline-flex;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  border: 1px solid #075eb8;
  border-radius: 0.625rem;
  background: #0967c2;
  padding: 0.65rem 1.25rem;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 750;
  box-shadow: 0 6px 14px rgba(9, 103, 194, 0.16);
}

.dashboard-register:hover {
  background: #0757a6;
}

.dashboard-main {
  padding: 0 2rem 2.5rem;
}

.dashboard-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #fecaca;
  border-radius: 0.625rem;
  background: #fef2f2;
  padding: 0.75rem 1rem;
  color: #b91c1c;
  font-size: 0.8125rem;
}

.dashboard-alert button {
  flex: 0 0 auto;
  font-weight: 700;
  text-decoration: underline;
}

.dashboard-summary {
  display: flex;
  min-height: 3.5rem;
  align-items: center;
  justify-content: flex-start;
  gap: 1.5rem;
  margin-bottom: 0.75rem;
}

.dashboard-summary-items {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.dashboard-summary-item {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: #17334a;
  font-size: 0.875rem;
}

.dashboard-summary-item i {
  color: #244768;
  font-size: 1.1rem;
}

.dashboard-summary-item.is-review,
.dashboard-summary-item.is-review i {
  color: #d46b08;
}

.dashboard-summary-item.is-session,
.dashboard-summary-item.is-session i {
  color: #058d8c;
}

.dashboard-summary-dot {
  color: #37516a;
  font-weight: 700;
}

.dashboard-filter {
  position: relative;
  display: flex;
  width: 12.5rem;
  height: 3rem;
  align-items: center;
}

.dashboard-filter select {
  width: 100%;
  height: 100%;
  appearance: none;
  border: 1px solid #cad6df;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0 2.5rem 0 2.5rem;
  color: #243b4c;
  font-size: 0.8125rem;
  font-weight: 650;
}

.dashboard-filter > i:first-of-type {
  position: absolute;
  left: 0.9rem;
  color: #637889;
  pointer-events: none;
}

.dashboard-filter > i:last-of-type {
  position: absolute;
  right: 0.9rem;
  color: #637889;
  font-size: 0.7rem;
  pointer-events: none;
}

.dashboard-content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(18rem, 25rem);
  gap: 1rem;
  align-items: start;
}

.dashboard-case-panel,
.dashboard-side-panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #d9e2e8;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 0 3px 10px rgba(15, 42, 60, 0.035);
}

.dashboard-panel-header,
.dashboard-side-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #dfe7ec;
}

.dashboard-panel-header {
  min-height: 4.5rem;
  flex-wrap: wrap;
  padding: 0.75rem 1.25rem;
}

.dashboard-panel-heading,
.dashboard-panel-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.dashboard-panel-heading {
  flex-wrap: wrap;
}

.dashboard-panel-controls {
  flex-wrap: wrap;
  max-width: 100%;
}

.dashboard-panel-controls .dashboard-search,
.dashboard-panel-controls .dashboard-filter {
  height: 2.5rem;
}

.dashboard-panel-header h2,
.dashboard-side-header h2 {
  color: #102536;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.015em;
}

.dashboard-panel-header span {
  color: #84939d;
  font-size: 0.6875rem;
}

.dashboard-state {
  display: flex;
  min-height: 18rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem;
  color: #6f828f;
  text-align: center;
}

.dashboard-state i {
  color: #91a3af;
  font-size: 1.5rem;
}

.dashboard-state span {
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.5;
}

.dashboard-table-wrap {
  width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.dashboard-table-wrap:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: -3px;
}

.dashboard-case-table {
  width: 100%;
  min-width: 61rem;
  border-collapse: collapse;
  table-layout: fixed;
}

.dashboard-case-table th {
  height: 3.2rem;
  border-bottom: 1px solid #e3e9ed;
  background: #fbfcfd;
  padding: 0 0.8rem;
  color: #4e6371;
  font-size: 0.6875rem;
  font-weight: 750;
  text-align: left;
}

.dashboard-case-table th:nth-child(1) {
  width: 18%;
}

.dashboard-case-table th:nth-child(2) {
  width: 12%;
}

.dashboard-case-table th:nth-child(3) {
  width: 33%;
}

.dashboard-case-table th:nth-child(4) {
  width: 12%;
}

.dashboard-case-table th:nth-child(5) {
  width: 16%;
}

.dashboard-case-table th:nth-child(6) {
  width: 9%;
}

.dashboard-case-table td {
  height: 6.25rem;
  border-bottom: 1px solid #e5ebef;
  padding: 0.75rem 0.8rem;
  color: #2f4656;
  font-size: 0.75rem;
  vertical-align: middle;
}

.dashboard-case-table tbody tr {
  cursor: pointer;
  transition: background-color 140ms ease;
}

.dashboard-case-table tbody tr:hover,
.dashboard-case-table tbody tr:focus-visible {
  background: #f7fbfe;
  outline: none;
}

.dashboard-code-cell {
  white-space: nowrap;
}

.dashboard-code-cell strong {
  color: #172e40;
  font-size: 0.75rem;
  font-weight: 700;
}

.dashboard-favorite {
  width: 1.65rem;
  height: 1.65rem;
  margin-right: 0.25rem;
  color: #aab7c1;
}

.dashboard-favorite:hover,
.dashboard-favorite .fa-solid {
  color: #0967c2;
}

.dashboard-trauma {
  color: #1f394d !important;
  font-weight: 650;
}

.dashboard-workflow {
  display: flex;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dashboard-workflow li {
  position: relative;
  display: flex;
  min-width: 3.2rem;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 0.28rem;
  color: #9aa8b3;
}

.dashboard-step-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  border-radius: 999px;
  background: #fff;
  color: #b8c4cd;
  font-size: 0.86rem;
}

.dashboard-workflow li.is-complete .dashboard-step-icon {
  color: #1268bc;
}

.dashboard-workflow li:last-child.is-complete .dashboard-step-icon {
  color: #078b8b;
}

.dashboard-step-line {
  position: absolute;
  z-index: 0;
  top: 0.42rem;
  left: calc(50% + 0.45rem);
  width: calc(100% - 0.9rem);
  border-top: 1.5px solid #cbd5dc;
}

.dashboard-workflow li.is-complete .dashboard-step-line {
  border-color: #2776c5;
}

.dashboard-step-label {
  color: #556b7a;
  font-size: 0.58rem;
  font-weight: 650;
  line-height: 1.2;
  white-space: nowrap;
}

.dashboard-progress-cell {
  white-space: nowrap;
}

.dashboard-progress-cell > strong {
  margin-right: 0.45rem;
  color: #142d40;
  font-weight: 750;
}

.dashboard-status,
.dashboard-session-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.45rem;
  padding: 0.25rem 0.45rem;
  font-size: 0.62rem;
  font-weight: 750;
  white-space: nowrap;
}

.dashboard-status.is-review_required {
  background: #fff5df;
  color: #d46b08;
}

.dashboard-status.is-approval_pending {
  background: #ebf3ff;
  color: #1464b4;
}

.dashboard-status.is-ready {
  background: #e6f7f4;
  color: #087c78;
}

.dashboard-status.is-in_progress {
  background: #eef2f6;
  color: #566c7a;
}

.dashboard-status.is-archived {
  background: #f0f1f3;
  color: #717a81;
}

.dashboard-next-action {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 0.45rem;
  color: #24506f;
  font-size: 0.7rem;
  font-weight: 650;
  text-align: left;
}

.dashboard-next-action i {
  flex: 0 0 auto;
  color: #0b66be;
  font-size: 0.85rem;
}

.dashboard-next-action:hover span {
  text-decoration: underline;
}

.dashboard-updated {
  color: #617583 !important;
  white-space: nowrap;
}

.dashboard-panel-footer {
  display: flex;
  min-height: 3.5rem;
  align-items: center;
  justify-content: center;
}

.dashboard-panel-footer a {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #0967c2;
  font-size: 0.75rem;
  font-weight: 750;
}

.dashboard-right-rail {
  display: grid;
  min-width: 0;
  gap: 1rem;
}

.dashboard-schedule-copy {
  min-width: 0;
}

.dashboard-side-header {
  min-height: 3.75rem;
  padding: 0 1rem;
}

.dashboard-side-header a {
  color: #0967c2;
  font-size: 0.68rem;
  font-weight: 750;
}

.dashboard-mini-calendar {
  max-width: 20rem;
  margin: 0 auto;
  padding: 0.8rem 1rem 0.9rem;
}

.dashboard-mini-calendar-heading,
.dashboard-mini-calendar-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dashboard-mini-calendar-heading strong {
  color: #203748;
  font-size: 0.76rem;
  font-weight: 800;
}

.dashboard-mini-calendar-nav {
  gap: 0.2rem;
}

.dashboard-mini-calendar-nav button {
  display: grid;
  width: 1.7rem;
  height: 1.7rem;
  place-items: center;
  border-radius: 0.4rem;
  color: #617583;
  font-size: 0.6rem;
}

.dashboard-mini-calendar-nav button:hover,
.dashboard-mini-calendar-nav button:focus-visible {
  background: #edf5fc;
  color: #0967c2;
}

.dashboard-mini-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.15rem;
  margin-top: 0.45rem;
}

.dashboard-mini-weekday,
.dashboard-mini-day {
  display: grid;
  min-width: 0;
  aspect-ratio: 1;
  place-items: center;
  border-radius: 0.4rem;
  font-size: 0.69rem;
}

.dashboard-mini-weekday {
  color: #84939d;
  font-weight: 700;
}

.dashboard-mini-weekday:first-child {
  color: #b85c61;
}

.dashboard-mini-day {
  color: #30495a;
  font-weight: 600;
}

.dashboard-mini-day.is-outside {
  color: #aab8c1;
}

.dashboard-mini-day.is-today {
  background: #0967c2;
  color: #fff;
  font-weight: 800;
}

.dashboard-mini-day:not(:disabled):hover,
.dashboard-mini-day:not(:disabled):focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: -2px;
}

.dashboard-schedule-item {
  display: grid;
  width: 100%;
  min-height: 4.6rem;
  grid-template-columns: 3.4rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.65rem;
  border-bottom: 1px solid #e5ebef;
  padding: 0.7rem 1rem;
  text-align: left;
}

.dashboard-schedule-item:hover {
  background: #f7fbfe;
}

.dashboard-schedule-item time {
  border-right: 1px solid #dce5eb;
  color: #0865c0;
  font-size: 0.78rem;
  font-weight: 750;
}

.dashboard-schedule-copy strong,
.dashboard-schedule-copy small {
  display: block;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dashboard-schedule-copy strong {
  color: #203748;
  font-size: 0.72rem;
  font-weight: 700;
}

.dashboard-schedule-copy small {
  margin-top: 0.2rem;
  color: #6e808c;
  font-size: 0.62rem;
}

.dashboard-session-chip {
  background: #e9f2fd;
  color: #1464b4;
}

.dashboard-session-chip.is-running {
  background: #e5f8f4;
  color: #087c78;
}

.dashboard-session-chip.is-paused,
.dashboard-session-chip.is-aborted {
  background: #fff1e6;
  color: #c55d0a;
}

.dashboard-session-chip.is-completed {
  background: #e7f7ed;
  color: #167a3c;
}

.dashboard-attention-item {
  display: grid;
  grid-template-columns: 1.6rem minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.55rem;
  border-bottom: 1px solid #e5ebef;
  padding: 0.8rem 1rem;
}

.dashboard-attention-icon {
  display: inline-flex;
  justify-content: center;
  padding-top: 0.12rem;
  color: #d97706;
}

.dashboard-attention-copy strong,
.dashboard-attention-copy small {
  display: block;
}

.dashboard-attention-copy strong {
  color: #203748;
  font-size: 0.72rem;
  font-weight: 700;
}

.dashboard-attention-copy small {
  margin-top: 0.2rem;
  color: #6c7e8b;
  font-size: 0.62rem;
  line-height: 1.4;
}

.dashboard-attention-action {
  text-align: right;
}

.dashboard-attention-action em,
.dashboard-attention-action button {
  display: block;
  white-space: nowrap;
}

.dashboard-attention-action em {
  color: #d97706;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 750;
}

.dashboard-attention-action button {
  margin-top: 0.28rem;
  color: #0967c2;
  font-size: 0.62rem;
  font-weight: 750;
}

.dashboard-side-empty {
  display: flex;
  min-height: 7rem;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  padding: 1rem;
  color: #81919b;
  font-size: 0.7rem;
  text-align: center;
}

.dashboard-side-empty.is-safe i {
  color: #18945c;
}

.dashboard-quick {
  padding: 1rem;
}

.dashboard-quick > h2 {
  margin-bottom: 0.7rem;
  color: #102536;
  font-size: 0.75rem;
  font-weight: 800;
}

.dashboard-quick nav {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-quick a {
  position: relative;
  display: block;
  min-width: 0;
  padding: 0.4rem 2rem 0.4rem 0.1rem;
}

.dashboard-quick a + a {
  border-left: 1px solid #dce5eb;
  padding-left: 1rem;
}

.dashboard-quick strong,
.dashboard-quick small {
  display: block;
}

.dashboard-quick strong {
  color: #0967c2;
  font-size: 0.68rem;
  font-weight: 750;
}

.dashboard-quick small {
  margin-top: 0.28rem;
  color: #71838f;
  font-size: 0.58rem;
  line-height: 1.45;
}

.dashboard-quick i {
  position: absolute;
  top: 50%;
  right: 0.65rem;
  color: #0967c2;
  transform: translateY(-50%);
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 3px solid rgba(9, 103, 194, 0.2);
  outline-offset: 2px;
}

@container wb-dashboard (max-width: 1350px) {
  .dashboard-header-inner,
  .dashboard-main {
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }
  .dashboard-content-grid {
    grid-template-columns: minmax(0, 1fr) 19rem;
  }
  .dashboard-case-table {
    min-width: 55rem;
  }
  .dashboard-case-table th:nth-child(3) {
    width: 31%;
  }
  .dashboard-case-table th:nth-child(5) {
    width: 18%;
  }
}
@container wb-dashboard (max-width: 1400px) {
  .dashboard-brand p,
  .dashboard-header-actions time {
    display: none;
  }
  .dashboard-content-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-right-rail {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-quick {
    grid-column: 1/-1;
  }
}
@container wb-dashboard (max-width: 760px) {
  .dashboard-header-inner {
    min-height: auto;
    flex-wrap: wrap;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .dashboard-brand {
    width: 100%;
  }
  .dashboard-brand-divider,
  .dashboard-brand p {
    display: none;
  }
  .dashboard-register span {
    display: none;
  }
  .dashboard-register {
    width: 3rem;
    padding: 0;
  }
  .dashboard-main {
    padding: 0.75rem;
  }
  .dashboard-summary {
    align-items: stretch;
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.5rem 0;
  }
  .dashboard-summary-items {
    overflow-x: auto;
    gap: 0.65rem;
    padding-bottom: 0.25rem;
  }
  .dashboard-summary-item {
    flex: 0 0 auto;
    font-size: 0.75rem;
  }
  .dashboard-panel-controls {
    width: 100%;
  }
  .dashboard-panel-controls .dashboard-search,
  .dashboard-panel-controls .dashboard-filter {
    width: auto;
    flex: 1 1 11rem;
  }
  .dashboard-right-rail {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-quick {
    grid-column: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dashboard-case-table tbody tr {
    transition: none;
  }
}
.dashboard-code-inline {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.2rem;
}

.dashboard-code-inline strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pane-table-hint {
  margin: 0;
  padding: 8px 14px;
  color: #526d8c;
  font-size: 12px;
  line-height: 1.5;
}

.dashboard-case-table th:nth-child(5), .dashboard-case-table td:nth-child(5) {
  position: sticky;
  right: 0;
  z-index: 1;
  background: #fff;
  box-shadow: -3px 0 6px rgba(26, 55, 83, 0.08);
}

.dashboard-case-table th:nth-child(5) {
  background: #f5f9fd;
}

.dashboard-code-cell {
  white-space: normal;
  overflow-wrap: anywhere;
}

.dashboard-code-cell strong {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dashboard-progress-cell {
  white-space: normal;
}

.dashboard-progress-cell .dashboard-status {
  max-width: 100%;
  white-space: normal;
}

.dashboard-next-action span {
  word-break: keep-all;
  overflow-wrap: anywhere;
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public patients: any[] = [];
    public visiblePatients: any[] = [];
    public todaySessions: any[] = [];
    public attentionCases: any[] = [];
    public patientCount: number = 0;
    public patientScope: 'all' | 'assigned' = 'assigned';
    public reviewCount: number = 0;
    public todaySessionCount: number = 0;
    public loading: boolean = true;
    public errorMessage: string = '';
    public searchText: string = '';
    public caseFilter: string = 'all';
    public todayLabel: string = this.formatToday();
    public calendarMonth: string = this.todayLabel.slice(0, 7);
    public calendarDays: any[] = this.buildCalendarDays(this.calendarMonth);
    public readonly calendarWeekdays: string[] = ['일', '월', '화', '수', '목', '금', '토'];
    public favorites: { [key: string]: boolean } = {};
    private loadSequence: number = 0;
    private caseFilterSubscription: Subscription | null = null;

    public traumaTypes: any[] = [
        { value: 'traffic_accident', label: '교통사고' },
        { value: 'flight_related', label: '비행 관련' },
        { value: 'disaster_accident', label: '재난·사고' },
        { value: 'violence_crime', label: '폭력·범죄' },
        { value: 'loss_bereavement', label: '상실·사별' },
        { value: 'other', label: '기타' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.caseFilterSubscription = this.route.queryParamMap.subscribe((params) => {
            this.caseFilter = params.get('case') === 'review' ? 'review' : 'all';
            this.applyFilters();
            void this.service.render();
        });
        this.patientScope = this.can('patients.read_all') ? 'all' : 'assigned';
        await this.load();
    }

    public ngOnDestroy() {
        this.caseFilterSubscription?.unsubscribe();
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public navigate(link: string) {
        if (link) this.service.href(link);
    }

    public openSchedule(appointment: any) {
        const date = String(appointment?.date || '');
        const id = String(appointment?.id || '');
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^[0-9a-f]{32}$/.test(id)) return;
        this.service.href(`/schedule?date=${date}&appointment=${id}`);
    }

    public calendarMonthLabel() {
        const [year, month] = this.calendarMonth.split('-');
        return `${year}년 ${Number(month)}월`;
    }

    public changeCalendarMonth(delta: number) {
        const [year, month] = this.calendarMonth.split('-').map(Number);
        this.calendarMonth = new Date(Date.UTC(year, month - 1 + delta, 1)).toISOString().slice(0, 7);
        this.calendarDays = this.buildCalendarDays(this.calendarMonth);
        void this.service.render();
    }

    public openCalendarDate(date: string) {
        if (!this.can('sessions.operate') || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return;
        this.service.href(`/schedule?date=${date}`);
    }

    private buildCalendarDays(month: string) {
        const [year, monthNumber] = month.split('-').map(Number);
        const firstWeekday = new Date(Date.UTC(year, monthNumber - 1, 1)).getUTCDay();
        const daysInMonth = new Date(Date.UTC(year, monthNumber, 0)).getUTCDate();
        const count = Math.ceil((firstWeekday + daysInMonth) / 7) * 7;
        return Array.from({ length: count }, (_value, index) => {
            const date = new Date(Date.UTC(year, monthNumber - 1, index - firstWeekday + 1));
            const value = date.toISOString().slice(0, 10);
            return {
                date: value,
                day: date.getUTCDate(),
                inMonth: value.slice(0, 7) === month,
                isToday: value === this.todayLabel.slice(0, 10)
            };
        });
    }

    public openPatientRegistration() {
        this.service.href('/patients?create=1');
    }

    public openPatient(patient: any) {
        const id = String(patient?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(id)) return;
        this.service.href(`/patients/${encodeURIComponent(id)}`);
    }

    public openCaseAction(patient: any, event?: Event) {
        if (event) event.stopPropagation();
        const route = String(patient?.next_route || '');
        if (route && route !== `/patients/${patient?.id || ''}`) {
            this.service.href(route);
            return;
        }
        this.openPatient(patient);
    }

    public openAttention(item: any) {
        const route = String(item?.route || '');
        if (route) {
            this.service.href(route);
            return;
        }
        this.openPatient(item);
    }

    private async fetchOverview() {
        return await wiz.call(
            'overview_live',
            { request_id: `${Date.now()}-${Math.random().toString(36).slice(2)}` },
            { cache: false }
        ) as any;
    }

    private shouldRetryOverview(data: any) {
        if (!this.can('patients.read_all')) return false;
        if (data?.patient_scope !== 'all') return true;
        const rows = Array.isArray(data?.patients) ? data.patients : [];
        return Number(data?.patient_count || 0) === 0 && rows.length === 0;
    }

    public async load() {
        const sequence = ++this.loadSequence;
        this.loading = true;
        this.errorMessage = '';
        this.patientScope = this.can('patients.read_all') ? 'all' : 'assigned';

        try {
            let response = await this.fetchOverview();
            let code = response?.code;
            let data = response?.data;

            // 로그인 직후 세션 동기화나 이전 API 코드 캐시가 남은 경우 한 번만 새 호출한다.
            if (code === 200 && this.shouldRetryOverview(data)) {
                await this.service.sleep(120);
                response = await this.fetchOverview();
                code = response?.code;
                data = response?.data;
            }

            if (sequence !== this.loadSequence) return;
            if (code === 200 && data) {
                const patients = Array.isArray(data.patients) ? data.patients : [];
                this.patients = patients;
                this.patientCount = Math.max(Number(data.patient_count || 0), patients.length);
                this.patientScope = data.patient_scope === 'all' ? 'all' : 'assigned';
                this.reviewCount = Number(data.review_count || 0);
                this.todaySessionCount = Number(data.today_session_count || 0);
                this.todaySessions = Array.isArray(data.today_sessions) ? data.today_sessions : [];
                this.attentionCases = Array.isArray(data.attention_cases) ? data.attention_cases : [];
                this.applyFilters();
                return;
            }
            this.errorMessage = data?.message || '대시보드를 불러오지 못했습니다.';
        } catch (error) {
            if (sequence !== this.loadSequence) return;
            this.errorMessage = '대시보드를 불러오지 못했습니다.';
        } finally {
            if (sequence === this.loadSequence) {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    public onSearch(event: Event) {
        const input = event.target as HTMLInputElement;
        this.searchText = input?.value || '';
        this.applyFilters();
    }

    public onFilterChange(event: Event) {
        const select = event.target as HTMLSelectElement;
        this.caseFilter = select?.value || 'all';
        this.applyFilters();
    }

    public patientScopeLabel() {
        return this.patientScope === 'all' ? '전체 환자' : '담당 환자';
    }

    public emptyPatientMessage() {
        if (this.searchText.trim() || this.caseFilter !== 'all') {
            return '검색 또는 필터 조건에 맞는 환자가 없습니다.';
        }
        if (this.patientScope === 'all') {
            return '등록된 환자가 없습니다.';
        }
        return '현재 계정에 배정된 환자가 없습니다.';
    }

    public applyFilters() {
        const query = this.searchText.trim().toLowerCase();
        this.visiblePatients = this.patients.filter((patient: any) => {
            const matchesText = !query || [
                patient.patient_code,
                this.traumaTypeLabel(patient),
                patient.next_action,
                patient.scenario_title
            ].some((value: any) => String(value || '').toLowerCase().includes(query));

            const matchesFilter = this.caseFilter === 'all'
                || (this.caseFilter === 'review'
                    && ['review_required', 'approval_pending'].includes(patient.status_key))
                || (this.caseFilter === 'ready' && patient.status_key === 'ready')
                || (this.caseFilter === 'active' && patient.status !== 'archived');

            return matchesText && matchesFilter;
        }).slice(0, 7);
    }

    public toggleFavorite(patient: any, event: Event) {
        event.stopPropagation();
        const key = String(patient?.id || '');
        this.favorites[key] = !this.favorites[key];
    }

    public isFavorite(patient: any) {
        return !!this.favorites[String(patient?.id || '')];
    }

    public traumaTypeLabel(patient: any) {
        if (patient?.trauma_type === 'other' && patient?.trauma_type_detail) {
            return patient.trauma_type_detail;
        }
        return this.traumaTypes.find((item: any) => item.value === patient?.trauma_type)?.label || '미지정';
    }

    public scheduleTraumaLabel(session: any) {
        if (session?.trauma_type === 'other' && session?.trauma_type_detail) {
            return session.trauma_type_detail;
        }
        return this.traumaTypes.find((item: any) => item.value === session?.trauma_type)?.label || '미지정';
    }

    public statusClass(key: string) {
        return `is-${key || 'in_progress'}`;
    }

    public trackById(index: number, item: any) {
        return item?.id || index;
    }

    private formatToday() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const part = (type: string) => parts.find((item: any) => item.type === type)?.value || '';
        const year = part('year');
        const month = part('month');
        const day = part('day');
        const weekday = ['일', '월', '화', '수', '목', '금', '토'][
            new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).getUTCDay()
        ];
        return `${year}-${month}-${day} (${weekday})`;
    }
}

export default PageDashboardComponent;